export default "__VITE_ASSET__6UPjajQr__"